export function generateUUID() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  // Fallback UUIDv4 generator
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


function createToken():string{
    // Use namespaced key to prevent collisions
    const STORAGE_KEY = 'witzo_chat_session_token';
    let session = sessionStorage.getItem(STORAGE_KEY);

    if(!session){
        session = generateUUID();
        sessionStorage.setItem(STORAGE_KEY, session);
    }

    return session;
}
export { createToken };

